import * as React from "react";
import { SingleNavMenuLinkCategory as ISingleNavMenuLinkCategory } from "../../../pages/identity/useNavMenu";

interface Props {
  link: ISingleNavMenuLinkCategory;
  index: number;
}
export const SingleNavMenuLinkCategory: React.FC<Props> = ({ link, index }) => {
  return <div className="mt-2 mb-0 px-4 text-xs uppercase tracking-wider font-semibold" style={{ color: "var(--color-label)" }}>{link.label}</div>;
};
